module.exports = __webpack_public_path__ + "img/salute-benessere-01.f1551414.svg";